<template>
  <div class="main">
    <iframe
      width="100%"
      height="100%"
      id="mainframe"
      scrolling="no"
      frameborder="no"
      title="Inline Frame Example"
      allow="microphone"
      :src="`https://ll-livespeaking.liveabc.com/AIStorybook/maker?token=${$store.state.auth.user.token}` ">
    </iframe>
  </div>
</template>
<script>

export default {
  name: 'CreateBook',
  data () {
    return {
    }
  },
  mounted () {
    const iframe = document.getElementById('mainframe')
    window.addEventListener('message', (event) => {
      if (event.data < window.innerHeight) {
        iframe.style.height = window.innerHeight + 'px'
      } else {
        iframe.style.height = event.data + 150 + 'px'
      }
    })
  },
  beforeDestroy () {
    const iframe = document.getElementById('mainframe')
    window.removeEventListener('message', (event) => {
      iframe.style.height = event.data + 'px'
    })
  },
  methods: {
  },
  components: {
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/styles/custom.scss";
  .main {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  #mainframe {
    min-height: 900px;
  }

</style>
